"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameName = void 0;
/**
 * Used to identify a game by it's name. See `GameEntity['name']`.
 */
var GameName;
(function (GameName) {
    GameName["Connect4"] = "Connect 4";
    GameName["Battleships"] = "Battleships";
    GameName["Gomoku"] = "Gomoku";
    GameName["Mimstris"] = "Mimstris";
    GameName["Lichess"] = "Lichess";
    GameName["Lidraughts"] = "Lidraughts";
    GameName["DeliveryDash"] = "Delivery Dash";
    GameName["BubbleUpEndless"] = "Bubble Up Endless";
    GameName["EvIo"] = "Ev.io";
    GameName["Lol"] = "League of Legends";
    /**
     * @deprecated Use `Mimstris` instead.
     */
    GameName["BlockTris"] = "BlockTris";
    /**
     * @deprecated Use `Lichess` instead.
     */
    GameName["Chess"] = "Chess";
    /**
     * @deprecated Use `Lidraughts` instead.
     */
    GameName["Draughts"] = "Draughts";
})(GameName = exports.GameName || (exports.GameName = {}));
//# sourceMappingURL=game-name.js.map